import React, { useEffect } from 'react'
import className from 'classnames/bind'
import { isEmpty } from 'lodash'
import { useHistory } from 'react-router'

import style from './MyhouseReviewEnrolMain.module.scss'

import MyhouseContents from '@Components/atoms/MyhouseContents'
import MyhouseImageAttach from '@Components/atoms/MyhouseImageAttach'
import MyhouseSwitch from '@Components/atoms/MyhouseSwitch'
import useBoardRegister from '@Hooks/myhouse/board/useBoardRegister'
import useModal from '@Hooks/myhouse/useModal'
import { MODAL_TYPE } from '@Root/contants/myhouseModal'
import useBoardImageRegister from '@Hooks/myhouse/board/useBoardImageRegister'
import useDebounce from '@Hooks/common/useDebounce'
import { FETCH_STATUS } from '@Root/contants'
import { TOAST_AFTER_EVENT, TOAST_TEXT } from '@Root/contants/myhouseToast'
import useToast from '@Hooks/myhouse/useToast'
import MyhouseCommunityRegistGuide from '@Components/atoms/MyhouseCommunityRegistGuide'
import MyhouseCommonButton from '@Components/atoms/MyhouseCommonButton'
import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import MyhouseReportPolicyGuide from '@Components/atoms/MyhouseReportPolicyGuide'
import { MY_HOUSE_BOARD_TYPE } from '@Root/contants/myhouse'
import { NCLICK, NDS_PROTOCOL } from '@Root/contants/lcs'
import { handleNclick } from '@Helpers/nclick'
import { lcsSend } from '@Helpers/lcs'

const cx = className.bind(style)

const MyhouseReviewEnrolMain: React.FC = () => {
  const { reduxBoardRegister, reduxMyhouse, loadBoardRegister, setContents, setCopyYn, setBbsTypeCode, setInitialState, initFetchStatus, loadPenalty } = useBoardRegister()

  const { bbsTypeCode, contents, copyYn, fetchStatus: registerFetchStatus, percentage, penalty } = reduxBoardRegister
  const { complexNo } = reduxMyhouse

  const { open } = useModal()
  const { show } = useToast()

  const { files, previewURLs, handleImageChange, handleRemoveClick, getFileSize } = useBoardImageRegister()
  const { landDebounce } = useDebounce()
  const debouncedLoadBoardRegister = landDebounce(loadBoardRegister)
  const history = useHistory()

  useEffect(() => {
    lcsSend(NDS_PROTOCOL.MY_HOUSE.REVIEW.ENROL)

    window.scrollTo(0, 0)
    setBbsTypeCode('REVIEW')
    loadPenalty()

    return () => {
      setInitialState()
      initFetchStatus()
    }
  }, [])

  useEffect(() => {
    if (penalty.fetchStatus === FETCH_STATUS.SUCCESS && penalty.code) {
      history.replace(LAND_SERVICE_PREFIX_URL.MYHOUSE_PENALTY)
      return
    }
  }, [penalty.fetchStatus])

  useEffect(() => {
    if (registerFetchStatus === FETCH_STATUS.SUCCESS) {
      show(TOAST_TEXT.ARTICLE_POSTED, TOAST_AFTER_EVENT.HISTORY_BACK)
    }
  }, [registerFetchStatus])

  const handleClick = (e: React.SyntheticEvent) => {
    e.preventDefault()
    handleNclick(NCLICK.MY_HOUSE.REVIEW_ENROL.COMPLETE, e)

    if (registerFetchStatus === FETCH_STATUS.PENDING) {
      return
    }

    if (isEmpty(contents) || isEmpty(contents.trim())) {
      open(MODAL_TYPE.CONTENT_REQUIRED)
      return
    }

    const param = {
      complexNo,
      bbsTypeCode,
      contents,
      copyYn,
    }
    debouncedLoadBoardRegister(param, files)
  }

  if (registerFetchStatus === FETCH_STATUS.PENDING && files.length > 0) {
    return <MyhouseCommunityRegistGuide percentage={percentage} />
  }

  return (
    <>
      <MyhouseContents handleBlur={setContents} content={contents} boardType={MY_HOUSE_BOARD_TYPE.REVIEW} />
      <MyhouseImageAttach
        previewURLs={previewURLs}
        fileSize={getFileSize()}
        handleImageChange={handleImageChange}
        handleRemoveClick={handleRemoveClick}
        boardType={MY_HOUSE_BOARD_TYPE.REVIEW}
      />
      <div className={cx('wrap_switch')}>
        <MyhouseSwitch description="복사 허용" isInit={copyYn} setChecked={setCopyYn} nclickChange={NCLICK.MY_HOUSE.REVIEW_ENROL.COPYABLE} />
      </div>
      <MyhouseReportPolicyGuide className={cx('guide')} boardType={MY_HOUSE_BOARD_TYPE.REVIEW} />
      <MyhouseCommonButton buttonText="등록하기" isFloating onClick={handleClick} />
    </>
  )
}

export default MyhouseReviewEnrolMain
